import { useMutation } from '@apollo/react-hooks';
import { kmsClient } from 'api';
import { REMOVE_TEXT_ASSET_FROM_ARTICLE_GROUP_MUTATION } from './removeTextAssetFromArticleGroup.mutation';
import {
  RemoveTextAssetFromArticleGroupMutation,
  RemoveTextAssetFromArticleGroupMutationVariables
} from './__generated__/RemoveTextAssetFromArticleGroupMutation';

type MutationProps = {
  onCompleted?: () => void;
  onError?: (errors: string[]) => void;
};

export const useRemoveTextAssetFromArticleGroup = ({
  onCompleted,
  onError
}: MutationProps): [(variables: RemoveTextAssetFromArticleGroupMutationVariables) => void, { loading: boolean }] => {
  const [mutationFunc, { loading }] = useMutation<
    RemoveTextAssetFromArticleGroupMutation,
    RemoveTextAssetFromArticleGroupMutationVariables
  >(REMOVE_TEXT_ASSET_FROM_ARTICLE_GROUP_MUTATION, {
    client: kmsClient,
    onCompleted: (data) => {
      if (data.removeTextAssetFromArticleGroup?.errors?.length) {
        if (onError) onError(data.removeTextAssetFromArticleGroup.errors);
      } else {
        if (onCompleted) onCompleted();
      }
    },
    onError: (error) => onError && onError([error.message])
  });

  return [(variables) => mutationFunc({ variables }), { loading }];
};
